import Store from '@/store';
import { Device, getDevices } from '../v1/api/client';

export function updateDevices(devices: Device[]) {
  Store.commit('updateDevices', devices);
}

export async function loadDevices(targetName: string) {
  try {
    const devices = await getDevices({ targetName });
    updateDevices(devices);
  } catch (e) {
    updateDevices([]);
    throw e;
  }
}
